var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wrap" } },
    [
      _vm.type == 3
        ? _c("div", { staticClass: "top" }, [
            _c(
              "ul",
              _vm._l(_vm.activeArr, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { active: index === _vm.curId },
                    on: {
                      click: function($event) {
                        return _vm.tab(index)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type != 3
        ? _c(
            "div",
            { staticClass: "switch_btn", on: { click: _vm.switchRight } },
            [_c("img", { attrs: { src: _vm.switchPic, alt: "" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curId == 0
        ? _c(
            "swiper",
            {
              staticClass: "swiper-no-swiping",
              staticStyle: { height: "calc(100vh - 190px)" },
              attrs: { id: "swiperContent", options: _vm.swiperOption }
            },
            _vm._l(_vm.resourceData, function(data, index) {
              return _c(
                "swiper-slide",
                {
                  key: index + "_" + data.id + "_" + data.isFinish,
                  staticClass: "swiper_list",
                  class: { swiper_active: data.id == _vm.resourceId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "swiper_items",
                      on: {
                        click: function($event) {
                          return _vm.sendMsg(data, index)
                        }
                      }
                    },
                    [
                      data.type == 1
                        ? _c("img", { attrs: { src: _vm.picture, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 2
                        ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 3
                        ? _c("img", { attrs: { src: _vm.audio, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 4
                        ? _c("img", { attrs: { src: _vm.video, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 5
                        ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.resourceType == 5
                        ? _c("img", { attrs: { src: _vm.testPic, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.resourceType != 3
                        ? _c("span", [_vm._v(_vm._s(data.name))])
                        : _vm._e(),
                      _vm._v(" "),
                      data.resourceType == 3
                        ? _c("div", { staticClass: "training" }, [
                            _c("span", [_vm._v(_vm._s("业务" + (index + 1)))]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  data.name ? data.name : "实操题" + data.id
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      data.taskType === 1 && _vm.sign != "preview"
                        ? _c("img", {
                            staticClass: "is_finish_pic",
                            attrs: {
                              src:
                                data.isFinish === 1
                                  ? _vm.isFinish
                                  : _vm.unFinish
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curId == 1
        ? _c(
            "swiper",
            {
              staticClass: "swiper-no-swiping",
              staticStyle: { height: "calc(100vh - 190px)" },
              attrs: { id: "swiperContent", options: _vm.swiperOption }
            },
            _vm._l(_vm.resourceMyData, function(data, index) {
              return _c(
                "swiper-slide",
                {
                  key: index + "_" + data.id + "_" + data.isFinish,
                  staticClass: "swiper_list",
                  class: { swiper_active: data.id == _vm.resourceId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "swiper_items",
                      on: {
                        click: function($event) {
                          return _vm.sendMsg(data, index)
                        }
                      }
                    },
                    [
                      data.type == 1
                        ? _c("img", { attrs: { src: _vm.picture, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 2
                        ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 3
                        ? _c("img", { attrs: { src: _vm.audio, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 4
                        ? _c("img", { attrs: { src: _vm.video, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.type == 5
                        ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.resourceType == 5
                        ? _c("img", { attrs: { src: _vm.testPic, alt: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      data.resourceType != 3
                        ? _c("span", [_vm._v(_vm._s(data.name))])
                        : _vm._e(),
                      _vm._v(" "),
                      data.resourceType == 3
                        ? _c("div", { staticClass: "training" }, [
                            _c("span", [
                              _vm._v(_vm._s("业务" + (data.indexs + 1)))
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  data.name ? data.name : "实操题" + data.id
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      data.taskType === 1 && _vm.sign != "preview"
                        ? _c("img", {
                            staticClass: "is_finish_pic",
                            attrs: {
                              src:
                                data.isFinish === 1
                                  ? _vm.isFinish
                                  : _vm.unFinish
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curId == 0
        ? _c("div", { staticClass: "task_num" }, [
            _vm._v(
              "共计" +
                _vm._s(_vm.resourceData ? _vm.resourceData.length : 0) +
                "个任务"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.curId == 1
        ? _c("div", { staticClass: "task_num" }, [
            _vm._v(
              "共计" +
                _vm._s(_vm.resourceMyData ? _vm.resourceMyData.length : 0) +
                "个任务"
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46046c2d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46046c2d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponent/swiper/index.vue
// module id = null
// module chunks = 